import styled from 'styled-components';

export const SecondaryButtonContainer = styled.button`
  box-sizing: border-box;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-xs);

  flex: 0 0 auto;

  width: auto;
  min-width: 120px;
  max-width: 260px;

  padding: var(--space-xs) var(--space-s);

  min-height: 36px;
  height: auto;

  border: 1px solid var(--grey2);
  border-radius: var(--borderRadiusButton);

  background: var(--white);

  color: var(--grey7) !important;

  font-size: 0.8rem;
  font-weight: 650;
  line-height: 1.1;
  letter-spacing: 0.02em;

  text-align: center;

  white-space: normal;
  overflow: visible;
  text-overflow: unset;

  cursor: pointer;

  box-shadow: var(--shadow-xs);

  transition:
    background 0.18s ease,
    color 0.18s ease,
    border-color 0.18s ease,
    box-shadow 0.18s ease,
    transform 0.16s ease;

  &:hover {
    background: var(--yellow1);
    border-color: var(--yellow4);
    color: var(--grey7) !important;

    transform: translateY(-1px);

    box-shadow: var(--shadow-sm);
  }

  &:active {
    transform: translateY(0);
    box-shadow: none;
  }

  &:disabled {
    background: var(--grey15);
    color: var(--grey3) !important;
    border-color: var(--grey1);

    opacity: 0.7;
    cursor: not-allowed;

    box-shadow: none;
    transform: none;
  }

  &:focus-visible {
    outline: 3px solid var(--yellow4);
    outline-offset: 3px;
  }

  @media (max-width: 768px) {
    padding: var(--space-xs) var(--space-s);

    font-size: var(--space-m);

    max-width: 60vw;
    min-height: 34px;
  }

  @media (max-width: 480px) {
    max-width: 90vw;
    min-height: 32px;
  }
`;
